import { z } from 'zod';

// Jedna tabuľka z jedného účtovného výkazu (Týždeň 3). `data` je surové pole hodnôt
// formulára (Úč POD 1-01/2-01 a pod.) — presné mapovanie index→riadok je TODO, viď
// docs/01-architektura-a-datove-zdroje.md a RÚZ šablóny (`/api/sablona?id=...`).
export const financialStatementSchema = z.object({
  id: z.string().uuid(),
  period: z.number(),
  filingType: z.string(),
  tableNameSk: z.string(),
  tableNameEn: z.string().nullable(),
  data: z.array(z.unknown()),
});
export type FinancialStatement = z.infer<typeof financialStatementSchema>;
